const _ = require('lodash');

export const permTippyTop = () => {
	addPermTippyTop();
	window.permTippyTopUpdateContent = addPermTippyTop;
};

var theContentForTippy = '';
var addPermTippyTop = () => {
	if(window.permTippyTopContent){
		if(theContentForTippy != window.permTippyTopContent){
			theContentForTippy = window.permTippyTopContent;
			if($('.perm-tippy-top').length > 0){
				//update content in tippy top
				$('.perm-tippy-top-contents').html(theContentForTippy);
			}else{
				//add tippy top to page
				var selectorToPrepend = $('header:first');
				if($('#layoutContent').length > 0){
					selectorToPrepend = $('#page').eq(0);
				}
				selectorToPrepend.prepend("<div class='perm-tippy-top' style='background-color:#C04747;text-align:center;color:white;position:relative;z-index:500;' ><div class='perm-tippy-top-contents' style='padding:5px;'>" + theContentForTippy + "<div/></div>");
				addPermTippyTopBinds();
			}
			resizePermTippyStyle();
		}
	}else{
		//tippy top verbiage is gone so remove the tippy top
		$('.perm-tippy-top').remove();
		$('#perm-tippy-top-style-constant').remove();
	}
}

var addPermTippyTopBinds = () => {
	$('body').append('<style id="perm-tippy-top-style-constant">.mobilePage.MobileMenuPos .perm-tippy-top, .mobilePage.bodyMobileSearchOpen .perm-tippy-top{display:none!important;}</style>');
	//need to add back if we need dynamic height info
	// $(window).on('resize.permTippyTop', _.throttle(() => {
	// 	resizePermTippyStyle();
	// }, 500));
}

var cachedTippyHeight = 0;
var resizePermTippyStyle = () => {
	var currentTippyHeight = $('.perm-tippy-top').height();
	if(currentTippyHeight != cachedTippyHeight){
		var styleString = '';
		if($('#perm-tippy-top-style').length == 0){
			$('body').append('<style id="perm-tippy-top-style">' + styleString + '</style>');
		}else{
			$('#perm-tippy-top-style').html(styleString);
		}
	}
}